import React from "react";
import {
  Wrench, Baby, BookOpen, Car, Smartphone, Hammer, Ruler, Briefcase,
  ShieldCheck, Scissors, Package, Truck, LayoutGrid, HelpCircle,
  Home, User, GraduationCap, PawPrint, PartyPopper, Hand,
} from "lucide-react";

const MAP = {
  Wrench, Baby, BookOpen, Car, Smartphone, Hammer, Ruler, Briefcase,
  ShieldCheck, Scissors, Package, Truck, LayoutGrid,
  Home, User, GraduationCap, PawPrint, PartyPopper, Hand,
};

export default function CategoryIcon({ name, size = 22, className = "", strokeWidth = 1.6 }) {
  const Icon = MAP[name] || HelpCircle;
  return <Icon size={size} strokeWidth={strokeWidth} className={className} />;
}
